import React from 'react';
import config from '../config';
import { Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Services
import AuthService from "../services/auth.service";

const { API_URL } = config.mediaforta;

const useStyles = makeStyles(() => ({
  avatar: { width: 110, height: 110 }
}));

export default function MediumAvatar({ medium, avatarId, classes = {} }) {
  const styles = useStyles();
  classes = { ...styles, ...classes };
  const user = AuthService.getCurrentUser() || {};
  const [avatar, setAvatar] = React.useState(false);

  React.useEffect(() => {
    if (avatarId || (medium)) { handleAction(); }
    // eslint-disable-next-line
  }, [avatarId, medium]);

  const handleAction = async () => {
    if (!medium.avatar) return setAvatar(false);
    const result = await fetch(`${API_URL}mediums/${medium._id}/file/${medium.avatar}`, {
      headers: {
        Authorization: "Bearer " + user.token,
        Prefer: 'count=exact'
      }
    });

    if (result.status !== 200) return;
    const blob = await result.blob();
    setAvatar(window.URL.createObjectURL(blob));
  };

  return (
    <>
      {/* eslint-disable-next-line*/}
      <Avatar src={avatar ? avatar : ''} className={classes.avatar}> M </Avatar>
    </>
  );
}